import { LoadPathActions, NavigationActions ,PageAnimationStages} from './NavigationActions.mjs';
import { buildPageUrl,  setRuleEvaluatorAnswers } from '../../utils';
import {
  extractAnswersFromPageResponse,
  extractAnswersWithPageInfoFromPageResponse,
  extractProductsFromPageResponse,
  extractQuestionsFromPageResponse,
  extractAttributesFromPageResponse,
  extractAnswersFromSession,
} from '../../state';


const navigationReducer = (state, action) => {
  switch (action.type) {
    case NavigationActions.PAGE_REQUEST_STARTED: {
      const { direction } = action;
      return {
        ...state,
        pages: {
          ...state.pages,
          isAnimatingPages: PageAnimationStages.STARTED,
          isLoadingNextPage: direction
        }
      };
    }

    case NavigationActions.PAGE_REQUEST_COMPLETED: {
      const { nextPage } = action;
      const type = nextPage.type;
      const stateAnswers = { ...state.answers };
      const pageAnswersFromServer = extractAnswersFromPageResponse(nextPage);
      const localAnswers = extractAnswersFromSession(state?.user?.uuid);
      const pageAnswersWithPageInfoFromServer = extractAnswersWithPageInfoFromPageResponse(nextPage);
      const products = extractProductsFromPageResponse(nextPage);

      //Clean up state answers
      if (type === 'survey') {
        const expectedAnswerKeys = [];
        const pageQuestions = extractQuestionsFromPageResponse(nextPage);
        const pageAttributes = extractAttributesFromPageResponse(nextPage);
        (pageQuestions || []).map((q) => expectedAnswerKeys.push(q.appkey));
        (pageAttributes.linkedQuestions || []).map((key) =>
          expectedAnswerKeys.push(key)
        );
        expectedAnswerKeys.map((key) => {
          if (
            Object.prototype.hasOwnProperty.call(stateAnswers, key) &&
            !Object.prototype.hasOwnProperty.call(pageAnswersFromServer, key)
          ) {
            delete stateAnswers[key];
          }
        });
      }

      const answers =
        type === 'summary'
          ? {
            ...localAnswers,
            ...pageAnswersFromServer,
          }
          : {
            ...localAnswers,
            ...stateAnswers,
            ...pageAnswersFromServer,
          };
      setRuleEvaluatorAnswers(answers);

      const url = buildPageUrl({
        ...nextPage.page,
        type,
        uuid: state.user.uuid,
      });

      return {
        ...state,
        answers,
        answersWithPageInfo: pageAnswersWithPageInfoFromServer,
        pages: {
          ...state.pages,
          currentPageUrl: url,
          currentPageType: type,
          isAnimatingPages: PageAnimationStages.RUNNING,
          isLoadingNextPage: false,
          savedPages: {
            ...state.pages.savedPages,
            [url]: nextPage.page,
          },
        },
        products
      };
    }

    case NavigationActions.PAGE_ANIMATION_COMPLETED: {
      return {
        ...state,
        pages: {
          ...state.pages,
          isAnimatingPages: PageAnimationStages.COMPLETED
        }
      };
    }

    case LoadPathActions.LOAD_PATHS_COMPLETED: {
      return {
        ...state,
        paths: action.payload
      };
    }

    default:
      return state;
  }
};

export default navigationReducer;
